const Merck = () => {
  return (
    <svg
      width="119"
      height="36"
      viewBox="0 0 119 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1061_7694)">
        <path
          d="M56.4832 9.19836H61.8123V26.4426H57.8634V14.8463L52.8116 26.4426L47.4948 14.8318V26.4426H43.8101V9.19836H49.0771L52.8744 18.1238L56.4832 9.19836Z"
          fill="#231F20"
        />
        <path
          d="M63.7759 9.19836V26.4426H73.6995V23.5191H67.6229V19.132H73.4483V16.181H67.6229V12.2247H73.6995V9.19836H63.7759Z"
          fill="#231F20"
        />
        <path
          d="M88.5005 17.8236C88.5005 24.2426 95.1821 29.3791 102.222 25.9435V22.2491C96.805 26.0541 92.0895 22.2404 92.1668 17.971C92.2196 15.1336 94.1213 12.4352 97.7999 12.2248C99.609 12.1218 100.834 12.5727 102.222 13.905V10.0631C97.1351 7.04064 88.5005 10.3672 88.5005 17.8236Z"
          fill="#231F20"
        />
        <path
          d="M103.846 26.4426H107.504V9.36426H103.846V26.4426Z"
          fill="#231F20"
        />
        <path
          d="M112.094 17.1955L117.621 9.40198H113.349L107.873 17.1809L114.231 26.4427H118.425L112.094 17.1955Z"
          fill="#231F20"
        />
        <path
          d="M75.4097 9.19824V26.4425H79.2702V17.1781L85.6516 26.4425H89.7667L84.7148 19.2017C87.0561 18.314 87.8157 16.3456 87.8157 14.3783C87.8157 12.4124 86.1699 9.19824 82.1826 9.19824H75.4097ZM79.2702 12.0678H80.9553C83.8043 12.0678 83.9564 13.9352 83.9564 14.6325C83.9564 15.9648 82.8289 17.0993 81.3737 17.0993H79.2702V12.0678Z"
          fill="#231F20"
        />
        <path
          d="M9.17364 9.19877C9.17364 4.43619 13.0245 0.575928 17.7738 0.575928C22.5246 0.575928 26.374 4.43619 26.374 9.19877H9.17364ZM9.17364 26.4437C9.17364 21.6819 13.0245 17.8209 17.7738 17.8209C13.0245 17.8209 9.17364 13.9613 9.17364 9.19877C4.42435 9.19877 0.574219 13.0591 0.574219 17.8209C0.574219 22.5842 4.42435 26.4437 9.17364 26.4437ZM9.17364 26.4437C9.17364 31.2071 13.0245 35.0666 17.7738 35.0666C22.5246 35.0666 26.374 31.2071 26.374 26.4437H9.17364ZM17.7738 17.8209C22.5246 17.8209 26.374 21.6819 26.374 26.4437C31.124 26.4437 34.9749 22.5842 34.9749 17.8209C34.9749 13.0591 31.124 9.19877 26.374 9.19877C26.374 13.9613 22.5246 17.8209 17.7738 17.8209Z"
          fill="#007A73"
        />
      </g>
      <defs>
        <clipPath id="clip0_1061_7694">
          <rect width="119" height="35.6425" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Merck;
